import React from "react";


function Timing() {
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/darsan.png)',backgroundSize:'cover',backgroundPosition:'center'}}></div>
      <div className="container" style={{backgroundImage:'url(./images/event.jpeg)',marginTop:'100px',marginBottom:'100px',padding:'50px'}}>
        <div className="row" style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
            <div className="col-md-7" style={{background:'#ffeccaf6',padding:'50px'}}>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px',background:'orange'}}>
                    <div className="col-md-12 middle">
                        <p className="enquiry">Darshan Timings / ദർശന സമയം</p>                                               
                    </div>
                </div>
                <div className="row" style={{marginBottom:'50px',paddingBottom:'15px',paddingTop:'15px'}}>
                    {/* <h3 className="heading">Morning</h3> */}
                    {/* first */}
                    <div className="col-md-6 " style={{padding:'10px',borderRight:'1px groove maroon'}}>
                        <h3 className="heading">Morning</h3>
                        <ul>
                            <li className="timelist">3:30 AM to 4:45 AM</li>
                            <li className="timelist">6:30 AM to 7:00 AM</li>
                            <li className="timelist">08:30 AM to 10:00 AM</li>
                            <li className="timelist">10:30 AM to 11:15 AM</li>
                            <li className="timelist">After 12:00</li>
                       </ul>
                    </div>
                    <div className="col-md-6 " style={{padding:'10px'}}> 
                        <h3 className="heading">Evening</h3>
                            <ul>
                             <li className="timelist">4:30 PM to 6:15 PM</li>
                            <li className="timelist">6:45 PM to 7:20 PM</li>
                            <li className="timelist">After Sreeveli</li>
                            </ul>
                   </div>
                    
                </div>
                
                
           </div> 
                      
        </div>
        
        
      </div>
    </div>
  );
}

export default Timing;